import { Outlet } from "react-router-dom";

export default function GovernmentSchemesLayout() {
  return <Outlet />;
}
